import { defineStore } from 'pinia'

import type { TutorLegalStore } from './interfaces'
import type { TutorLegalForm } from '@ts-tutor-legal/interfaces'

import { TUTOR_LEGAL_FIELD_MAP } from '@config/tutor-legal'

import { actions } from './actions'
import { getters } from './getters'

const emptyForm = (): TutorLegalForm =>
  Object.fromEntries(TUTOR_LEGAL_FIELD_MAP.map(entry => [entry.form, ''])) as unknown as TutorLegalForm

export const useTutorLegalStore = defineStore('tutor-legal', {
  state: (): TutorLegalStore => ({
    billing: null,
    form: emptyForm(),
    errors: {},
    existingFiles: [],
    pendingFiles: [],
    loading: false,
  }),
  actions,
  getters,
})
